<template>
  <div class="body">
    <div class="popup">
      <div class="t-c">
        <img src="@/assets/dzp/t_h2.png" alt="" />
      </div>
      <van-field v-model="iccid" name="mobile" label="充值号：" placeholder="请输入设备背面充值号"
        :rules="[{ required: true, message: '请输入设备背面充值号' }]" />
      <van-button class="bu_tn" round block type="info" native-type="submit" @click="onSubmit">确认</van-button>
    </div>

    <div class="more-dialog" v-if="isDialogShow">
      <div class="more-bg"></div>
      <div class="more-list">
        <div class="more-title">选择登录卡号</div>
        <div class="more-list-flex">
          <template v-for="(item, index) in phoneList">
            <div class="more-list-item" :key="index" @click="selectIon(item, index)"
              :class="{ 'active': index === inx }">
              <img src="@/assets/userNew/2.png" alt="" v-if="item.poolName === '联通'">
              <img src="@/assets/userNew/3.png" alt="" v-else-if="item.poolName === '移动'">
              <img src="@/assets/userNew/4.png" alt="" v-else-if="item.poolName === '电信'">
              <img src="@/assets/userNew/1.png" alt="" v-else>
              <div class="num">{{ item.cardNo }}</div>
            </div>
          </template>
        </div>
        <div class="dialog-btn">
          <div class="close" @click="isDialogShow = false">取消</div>
          <div class="corm" @click="onSubmit">确定</div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
import Advertisement from "@/components/Advertisement";
export default {
  data() {
    return {
      isDialogShow: false,
      phoneList: '',

      code: "",
      iccid: "",
    };
  },
  async created() {
    var source = this.getQueryVariable("source")
      ? this.getQueryVariable("source")
      : process.env.VUE_APP_APPID;
    localStorage.setItem("isHeadquarterAppid", true);
    var appid = source ? source : process.env.VUE_APP_APPID;

    if (this.$route.query.iccid) {
      this.iccid = this.$route.query.iccid;
    }
    //获取总部公众号appid
    await wxRequest("/sim/appId", {}, "post").then((res) => {
      if (res.data.code == 200) {
        appid = res.data.data.collectAppid;
      }
    });
    this.$store.commit("setIsHeadquarterAppid", "true");
    localStorage.setItem("isHeadquarterAppid", true);
    localStorage.setItem("appid", appid);
    console.log(appid);

    //先查询是否是乐刷支付 如果是乐刷支付 就不用授权了
    await wxRequest(
      "sim/get/pay/state",
      {
        iccid: localStorage.getItem("iccid"),
      },
      "post"
    ).then((res) => {
      localStorage.setItem("payCode", res.data.code);
      if (res.data.code == 200) {
        localStorage.setItem("leshuaPay", 1);
      } else {
        localStorage.setItem("leshuaPay", 2);
      }
    });
    await wxRequest("sim/is/wx/login", { iccid: localStorage.getItem('iccid') }, 'post').then(res => {
      if (res.data.data == 1) {
        this.code = 1;
        if (this.$route.query.iccid) {
          this.iccid = this.$route.query.iccid;
        } else {
          this.iccid = localStorage.getItem("recordLoginText");
        }
      } else {
        var redirectUrl = window.location.href;
        var index = redirectUrl.indexOf('code');
        redirectUrl = encodeURIComponent(redirectUrl);
        if (index < 0) {
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
        } else {
          var search = window.location.search;
          console.log('search', search);
          var startIndex = search.indexOf('code');
          var endIndex = search.indexOf('&', startIndex);
          var str = search.slice(startIndex, endIndex);
          var code = str.slice(str.indexOf('=') + 1);
          this.code = code;
          if (this.$route.query.iccid) {
            this.iccid = this.$route.query.iccid;
          } else {
            this.iccid = localStorage.getItem("recordLoginText");
          }
        }
      }
    })

  },
  methods: {
    selectIon(item, index) {
      this.inx = index
      this.iccid = item.cardNo
    },


    //获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    onSubmit() {
      let recordLoginText = this.iccid;
      let data = {
        requestId: this.iccid,
        code: this.code,
      };
      wxRequest("sim/bind", data, "get").then((res) => {
        if (res.data.code == 200) {
          let record = res.data.data;
          let iccid = record.iccid;
          localStorage.setItem('isHuiYuan', record.isHuiYuan);
          localStorage.setItem('isNewPage', record.isNewPage);
          this.$store.state.isNewPage = record.isNewPage;
          localStorage.setItem('newHomeImg', record.newHomeImg);
          localStorage.setItem('newHomeUrl', record.newHomeUrl);
          localStorage.setItem("isAuth", record.isAuth);
          localStorage.setItem("isCode", true);
          localStorage.setItem("basePkgGroup", record.basePkgGroup);
          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("shebeiLogin", 1);
          localStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("isSale", record.isSale);
          localStorage.setItem("yucun", record.yucun);
          localStorage.setItem("kefuUrl", record.kefuUrl);
          localStorage.setItem("salePrice", record.salePrice);//充值金额 元
          localStorage.setItem("havePrice", record.havePrice);//得到金额 元
          localStorage.setItem("priceImgUrl", record.priceImgUrl);
          localStorage.setItem("ishavePkg", record.ishavePkg);
          localStorage.setItem("isSale", record.isSale);
          localStorage.setItem("ishavePrice", record.ishavePrice);
          sessionStorage.setItem("isLine", true);
          localStorage.setItem("flowRatePool", record.flowRatePool);
          this.$store.state.flowRatePool = res.data.data.flowRatePool;
          localStorage.setItem("iccid", record.iccid);
          localStorage.setItem("openId", record.openId);
          localStorage.setItem("virtualNo", record.virtualNo);

          localStorage.setItem("userPhone", record.userPhone);
          this.$store.state.userPhone = record.userPhone;

          this.$store.state.recordLoginText = recordLoginText;
          this.$store.state.supplierCode = res.data.data.supplierCode;
          this.$store.state.iccid = iccid;
          this.$store.commit("setIccid", iccid);

          this.$store.state.intoNo = record.intoNo;
          sessionStorage.setItem("intoNo", record.intoNo);
          //未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
          let cardType = record.supplierTypeCode;
          let _data = {
            requestId: iccid,
            code: this.code,
          };
          if (record.toOther && record.toOther.length > 5) {
            window.location.href = record.toOther + "?iccid=" + this.iccid
          } else if (record.isToYuCun != 1) {
            this.$router.replace("/user/openPriceTi");
          } else if (
            (record.isSale == 1 || record.isSale == 3) &&
            record.ishavePrice == 0
          ) {
            this.$router.replace("/user/simOpens");
          } else {
            let _data = { iccid: record.iccid };
            wxRequest("bindPhone/state", _data, "post").then((res) => {
              if (res.data.code == 200) {
                let result = res.data.data;
                localStorage.setItem(
                  "applyChangeSimState",
                  result.applyChangeSimState
                );
                if (result.bindState == 2) {
                  this.$router.push({
                    path: "/user/bindPhoneOnely",
                    query: {
                      iccid: record.iccid,
                    },
                  });
                } else {
                  localStorage.setItem("phoneNo", result.userPhone);
                  if (record.isNewPage == 0) {
                    this.$router.replace('/user/home');
                  } else {
                    this.$router.replace('/userNew/home');
                  }
                }
              } else {
                Dialog.alert({ title: "提示", message: res.data.message });
              }
            });
          }
        } else if (res.data.code == 666) { //此时要弹出手机绑定列表，让用户来选择登录的卡号。 用户选择完卡号之后  继续请求 userQuerySIM 方法
          this.phoneList = res.data.data; // cardNo 表示展示的卡号。 poolName 表示类型
          this.isDialogShow = true
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.body {
  .more-dialog {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10001;

    .more-bg {
      background: rgba(0, 0, 0, .3);
      width: 100%;
      height: 100%;
    }

    .more-list {
      width: 90%;
      height: 400px;
      background: #fff;
      border-radius: 10px;
      position: absolute;
      top: 0;
      left: 0;
      margin: auto;
      bottom: 0;
      right: 0;

      .more-title {
        text-align: center;
        font-size: 19px;
        border-radius: 14px;
        font-weight: 600;
        color: #222222;
        height: 51px;
        padding-top: 22px;
        background: linear-gradient(180deg, #DAE8FF 0%, rgba(255, 255, 255, 0) 100%);
      }

      .more-list-flex {
        overflow: auto;
        height: 220px;
      }

      .more-list-item {
        display: flex;
        height: 60px;
        width: 85%;
        margin: 0 auto 8px;
        border: 1px solid #EEF4FF;
        align-items: center;

        img {
          width: 65px;
          height: 18px;
          margin-left: 10px;
          margin-right: 20px;
        }

        .num {
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #94959A;
          line-height: 20px;
        }
      }

      .active {
        border: 1px solid #1772FF;
      }

      .dialog-btn {
        display: flex;
        position: absolute;
        bottom: 18px;
        width: 100%;
        height: 40px;
        justify-content: space-around;

        .close {
          width: 121px;
          height: 44px;
          background: #F5F5F5;
          border-radius: 7px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          text-align: center;
          line-height: 44px;
        }

        .corm {
          width: 121px;
          height: 44px;
          background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
          border-radius: 7px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #fff;
          text-align: center;
          line-height: 44px;
        }
      }
    }

  }


  background: url("../../assets/dzp/shebei.png") no-repeat center;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: relative;

  .popup {
    background: linear-gradient(0deg, #ffe1b1, #fff);
    box-sizing: border-box;
    padding: 25px 0;
    width: 325px;
    position: fixed;
    left: 0;
    right: 0;
    margin: auto;
    top: 25%;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    box-shadow: 0 6px 6px 0 rgb(219 0 0 / 75%);

    .t-c {
      height: 60px;
      text-align: center;

      img {
        height: 100%;
      }
    }

    .van-cell {
      height: 50px;
      width: 275px;
      border-radius: 17px;
      border: 2px solid #000;
      padding-left: 10px;
      background: none;
      margin: auto;
      margin-top: 20px;

      ::v-deep .van-cell__title {
        width: 56px;
      }

      ::v-deep .van-cell__value {
        .van-field__body {
          .van-field__control {
            line-height: 24px;
          }
        }
      }
    }

    .bu_tn {
      height: 50px;
      line-height: 50px;
      text-align: center;
      width: 275px;
      color: #fff;
      background: #d33643;
      border-radius: 17px;
      margin: auto;
      margin-top: 20px;
      border: 1px solid #d33643;
    }
  }
}
</style>